<template>
  <div>
    <div class="mt-8">
      <v-row dense>
        <v-col
          cols="12"
          md="12"
          v-if="!isEditMode || sessionSpeakersDetails.length == 0"
        >
          <div class="text-subtitle-1 font-weight-bold">Speakers</div>
        </v-col>

        <v-col
          cols="12"
          v-if="!isEditMode || sessionSpeakersDetails.length == 0"
        >
          <div>
            Spotlight your panelist/speaker by creating a profile to display in
            your EventConnect link. If your Speakers would like to connect
            and/or interact with others at your event, we suggest you encourage
            them to join the link by inviting them to opt-in as you would be
            doing for other attendees.
          </div>
        </v-col>
        <v-col cols="12" md="8">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :outlined="!isEditMode || sessionSpeakersDetails.length == 0"
                depressed
                v-on="on"
                v-bind="attrs"
                color="primary"
                large
                >+ Add speaker</v-btn
              >
            </template>
            <v-list>
              <v-list-item @click="handleShowAddSpeakerDialog">
                <v-list-item-title>Add new speaker</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="handleShowAddExistingSpeakerDialog"
                v-if="existingSpeakers.length > 0"
              >
                <v-list-item-title>Add existing speaker</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col md="4" sm="12" v-if="sessionSpeakersDetails.length > 0">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search for a speaker"
            outlined
            single-line
            hide-details
            placeholder="Search for a speaker"
            rounded
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <v-dialog
      width="650"
      persistent
      v-model="showAddEditSpeakerDialog"
      v-if="showAddEditSpeakerDialog"
      scrollable
    >
      <AddSpeakerDialog :speaker="currentSpeaker"
                        :is-edit="isSpeakerEdit"
                     @added="handleAddSpeaker"
                    @close="handleCloseAddEditSpeakerDialog"
                    />
    </v-dialog>

    <v-data-table
      class="mt-3"
      v-if="this.speakers.length > 0"
      :headers="headers"
      :items="sortedSpeakers"
      :items-per-page="8"
      :key="`speakerList${dataTableKey}`"
    >
      <template v-slot:item.name="{ item }">
        <v-list-item>
          <UserAvatar
            :key="item.speakerId"
            :usersInitials="item.firstName[0] + ' ' + item.lastName[0]"
            :displayImageUrl="item.displayImageURL"
          />

          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">
              {{ item.firstName + " " + item.lastName }}</v-list-item-title
            >
            <!-- <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:item.jobTitle="{ item }">
        {{
          item.jobTitle != "" && item.jobTitle != undefined
            ? item.jobTitle
            : "-"
        }}
      </template>
      <!-- <template v-slot:item.status="{ item }">
        <div class="px-0">
          {{ getSpeakerStatus(item) }}
        </div>
      </template> -->
      <template v-slot:item.businessName="{ item }">
        {{
          item.businessName != "" && item.businessName != undefined
            ? item.businessName
            : "-"
        }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-menu offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list nav>
            <v-list-item @click="handleEditSpeaker(item)">
              <v-list-item-title>Edit information</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item v-if="item.email!=='' && item.email!=undefined && item.status!=='Joined'" @click="sendInvitationEmail(item)">
              <v-list-item-title>Send Invitation</v-list-item-title>
            </v-list-item> -->
            <v-list-item
              @click="handleRemoveSpeaker(item)"
              v-if="!hasSpeakerOptedIn(item)"
            >
              <v-list-item-title>Remove speaker</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="showBusinessCardOnDevice(item.businessCardId)"
              v-if="item.businessCardId != ''"
            >
              <v-list-item-title>View Profile</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <ConfirmationDialog
      :show="showConfirmationDialog"
      :title="confirmationDialogTitle"
      :content="confirmationDialogContent"
      @click="removeSpeaker"
      @closeDialog="showConfirmationDialog = false"
      buttonText="Remove speaker"
    />

    <!--Start: Show add existing speaker dialog--->
    <v-dialog
      width="500"
      persistent
      v-model="showAddExistingSpeakerDialog"
      scrollable
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-start"
          ><div style="max-width: 90%">
            Select existing speaker for {{ currentSession.name }}
          </div>
          <v-btn fab text small @click="handleCloseExistingSpeakerDialog" right
            ><v-icon>close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                placeholder="Search for a speaker name"
                v-model="searchExistingSpeaker"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-data-table
                v-model="selectedSpeakers"
                :custom-filter="customSearch"
                :search="searchExistingSpeaker"
                hide-default-header
                hide-default-footer
                :headers="existingSpeakerHeaders"
                :items="existingSpeakers"
                show-select
                item-key="speakerId"
                checkbox-color="#F15F31"
              >
                <template v-slot:item.name="{ item }">
                  <v-list-item>
                    <UserAvatar
                      :key="item.speakerId"
                      :usersInitials="
                        item.firstName[0] + ' ' + item.lastName[0]
                      "
                      :displayImageUrl="item.displayImageURL"
                    />

                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        {{
                          item.firstName + " " + item.lastName
                        }}</v-list-item-title
                      >
                      <v-list-item-subtitle>{{
                        item.email
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <!-- github link: https://github.com/vuetifyjs/vuetify/issues/8432 -->
                <template
                  v-slot:item.data-table-select="{ isSelected, select }"
                >
                  <v-checkbox
                    :input-value="isSelected"
                    @change="select($event)"
                    color="primary"
                  ></v-checkbox>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row>
            <v-col cols="5" offset="7" class="text-right"
              ><v-btn
                depressed
                class="primary"
                large
                width="150"
                @click="addExistingSpeakersToSession"
                >Add {{ selectedSpeakers.length }}
                {{
                  selectedSpeakers.length == 1 ? "speaker" : "speakers"
                }}</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--End: Show add existing speaker dialog--->

    <LoadingDialog title="Adding speaker" :show="showLoadingDialog" />
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import UserAvatar from "@/components/UserAvatar";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import LoadingDialog from "@/components/LoadingDialog";
import Speaker from "@/models/Speaker";
import SpeakerRelations from "@/models/SpeakerRelations";
import AddSpeakerDialog from "@/components/MultiConnect/Session/AddSpeakerDialog.vue";
import Attendee from "@/models/Attendee";
import {getBusinessCardsDoc, getHttpsCallable, updateSpeakerDoc} from "@/shared/firebase_utils";

let uuid = require("uuid");

export default {
  computed: {
    ...mapGetters([
      "selectedBusinessProfileId",
      "businessProfile",
      "currentSubEvent",
      "currentEvent",
      "userProfile",
      "currentSession",
    ]),

    // speakers() {},
    isEditMode() {
      return !this.currentSession.isCreationInProgress;
    },
    isSaveSpeakerEnabled() {
      console.log("this.isFormValid: ", this.isFormValid);
      console.log(
        "this.currentSpeaker.displayImageURL: ",
        this.currentSpeaker.displayImageURL != ""
      );
      return this.isFormValid && this.currentSpeaker.displayImageURL != "";
    },
    existingSpeakers() {
      return this.currentEvent.speakers || [];
    },
    sortedSpeakers() {
      let sortedArray = this.speakers.sort(function (a, b) {
        return a.firstName.localeCompare(b.firstName);
      });
      return sortedArray;
    },
  },
  data() {
    return {
      showAddEditSpeakerDialog: false,
      isSpeakerEdit: false,
      firstName: "",
      lastName: "",
      email: "",
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        { text: "Job Title", value: "jobTitle", align: "start" },
        { text: "Company", value: "businessName", align: "start" },

        //  { text: "Status", value: "status", align: "start" },
        // {
        //   text: "Email",
        //   value: "email",
        //   align: "start",
        // },

        { text: "Actions", value: "action", align: "center" },
      ],
      search: "",
      sessionSpeakersDetails: [],
      showConfirmationDialog: false,
      confirmationDialogTitle: "",
      confirmationDialogContent: "",
      speakerToBeRemoved: null,
      showLoadingDialog: false,
      currentSpeaker: {},
      dataTableKey: 0,
      showAddExistingSpeakerDialog: false,
      existingSpeakerHeaders: [
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        { text: "", value: "data-table-select" },
      ],
      searchExistingSpeaker: "",
      selectedSpeakers: [],
      speakers: [],
      // unsubscribeSpeakerSnapshot: null
    };
  },
  components: {
    AddSpeakerDialog,
    UserAvatar,
    ConfirmationDialog,
    LoadingDialog,

  },
  destroyed() {
    // this.unsubscribeSpeakerSnapshot();
  },
  created() {

 /*   this.unsubscribeSpeakerSnapshot = firebase.firestore().collection("speakers")
        .where("associatedSpeakerSessions", "array-contains", this.currentSession.id)
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            let addedSpeaker;
            if (change.type === "added" || change.type == "modified") {
              addedSpeaker = Speaker.fromObject(change.doc.data());
            }
            if (change.type === "added") {
              this.speakers.push(addedSpeaker);
            } else if (change.type == "modified") {
              console.log("modified");
              this.speakers.forEach((item, index) => {
                if (item.speakerDocId == change.doc.id) {
                  this.speakers.splice(index, 1, addedSpeaker);
                }
              });
            } else if (change.type == "removed") {
              //Remove the object from the array
              this.speakers.forEach((item, index) => {
                if (item.speakerDocId == change.doc.id) {
                  this.speakers.splice(index, 1);
                }
              });
            }
          });
        });*/
    this.initializeSpeakers();
     this.initializeSessionSpeakerDetails();
  },
  watch: {
    // speakers: function () {
    //   console.log("speakers changed");
    //   this.initializeSessionSpeakerDetails();
    // },
    "currentEvent.speakers": function () {
      this.initializeSpeakers();
    },
  },

  methods: {
    ...mapActions(["showSnackbar"]),
    // async handleAddSpeaker() {
    //   let associatedSpeakerSessions = [this.currentSession.id];
    //   let associatedSubEvents = [this.currentSubEvent.id];
    //   let invitee = new Attendee({
    //     email: this.email,
    //     firstName: this.firstName,
    //     lastName: this.lastName,
    //     attendeeId: uuid.v4(),
    //     invitedAt: new Date(),
    //     associatedSpeakerSessions: associatedSpeakerSessions,
    //     associatedSubEvents: associatedSubEvents,
    //     uid: uuid.v4(),
    //     accessToken: uuid.v4(),
    //   });

    //   //Close the dialog
    //   this.showAddEditSpeakerDialog = false;

    //   //Show loading dialog
    //   this.showLoadingDialog = true;

    //   await invitee.generatePrivateLink(
    //     this.currentEvent.id,
    //     this.currentEvent.name
    //   );

    //   this.currentEvent.invitees.unshift(invitee);

    //   //Save
    //   this.currentEvent.save();

    //   // let isSuccess = await this.sendInvitationEmail(invitee);

    //   //Hide loading dialog
    //   this.showLoadingDialog = false;

    //   //Reset the form
    //   this.$refs.addSpeakerForm.reset();

    //   //Show the snackbar
    //   // let snackbarText = isSuccess
    //   //   ? "Speaker added successfully!"
    //   //   : "Error occurred, please try again";
    //   let snackbarText = "Speaker added successfully!";
    //   this.showSnackbar({ show: true, text: snackbarText });

    //   //Start: Show invitee in the data-table
    //   // this.initializeSessionSpeakerDetails();
    //   //End: Show invitee in the data-table
    // },
    async sendInvitationEmail(speaker) {
        let invitee = {};
        let invitationLink = "";
        const inviteeIndex = this.currentEvent.invitees.findIndex((element) => element.speakerId === speaker.speakerId);
        if (inviteeIndex != -1) {
          invitee = this.currentEvent.invitees[inviteeIndex];

        } else {
          invitee = new Attendee({
            email: speaker.email,
            firstName: speaker.firstName,
            lastName: speaker.lastName,
            attendeeId: uuid.v4(),
            invitedAt: new Date(),
            associatedSpeakerSessions: speaker.associatedSpeakerSessions,
            associatedSubEvents: [this.currentSubEvent.id],
            uid: uuid.v4(),
            accessToken: uuid.v4(),
            isSpeaker: true,
            speakerId: speaker.speakerId,
          });
          await invitee.generatePrivateLink(
              this.currentEvent.id,
              this.currentEvent.name
          );
          this.currentEvent.invitees.unshift(invitee);
          this.currentEvent.save();
        }
      invitationLink = invitee.dynamicLink;

      let result = await invitee.sendInvitation(
        this.currentEvent.linkPrivacy,
        invitationLink,
        this.currentEvent.name,
        this.userProfile.firstName,
        this.userProfile.lastName,
        this.currentEvent.hostName
      );
      speaker.status = "Invited";
      await speaker.updateSpeaker(this.speakers, this.currentEvent.id, false);
      const isSuccess =  result.data.success;
        let snackbarText = isSuccess
          ? "Invitation Sent Successfully!"
          : "Failed to Send Invitation, please try again";
        await this.showSnackbar({ show: true, text: snackbarText });
    },
    initializeSessionSpeakerDetails() {
      this.speakers.forEach((speaker) => {
        //Check if speaker's data has been fetched already
        let isSpeakerDetailsFetched = this.sessionSpeakersDetails.some(
          (item) => {
            return item.invitedEmail == speaker.email;
          }
        );



        //If speaker hasn't been fetched already, fetch them or add them
        if (!isSpeakerDetailsFetched) {
          if (speaker.businessCardId != "") {
            let isBusinessCardRetrieved = false;

            for (let i = 0; i < this.speakers.length; i++) {
              if (this.speakers[i].id == speaker.businessCardId) {
                isBusinessCardRetrieved = true;
                break;
              }
            }

            if (!isBusinessCardRetrieved) {
              getBusinessCardsDoc(speaker.businessCardId)
                .then((doc) => {
                  if (doc.exists)
                    this.sessionSpeakersDetails.push({
                      id: doc.id,
                      ...speaker,
                      ...doc.data(),
                      invitedEmail: speaker.email,
                    });
                });
            }
          } else {

            this.sessionSpeakersDetails.push({
              ...speaker,
              invitedEmail: speaker.email,
            });
          }
        } else {
          console.log("speaker has been fetched already");
        }
      });
    },
    handleRemoveSpeaker(speaker) {
      this.speakerToBeRemoved = speaker;
      this.confirmationDialogTitle =
        "Remove speaker from " + this.currentSession.name + "?";
      this.confirmationDialogContent =
        speaker.firstName +
        " " +
        speaker.lastName +
        " will be removed from the list of speakers.";
      // in the app and notified of the change.
      this.showConfirmationDialog = true;
    },
    async removeSpeaker() {
      //Find index of the speaker
      let index = this.currentEvent.speakers.findIndex(
        (speaker) => speaker.speakerId == this.speakerToBeRemoved.speakerId
      );


      //Delete speaker from array or update speaker's associated speaker sessions
      if (this.speakerToBeRemoved.associatedSpeakerSessions.length == 1) {
        //Remove the speaker from the event's list of speakers
        this.currentEvent.speakers.splice(index, 1);
      } else {
        //Update the sessions of speaker to remove current session id
        this.currentEvent.speakers[index].associatedSpeakerSessions =
          this.currentEvent.speakers[index].associatedSpeakerSessions.filter(
            (sessionId) => sessionId != this.currentSession.id
          );

      }


      if (this.speakerToBeRemoved.speakerId!==null && this.speakerToBeRemoved.speakerId !== undefined && !this.speakerToBeRemoved.speakerId.includes('-')) {
        const doesSpeakerExists = await this.speakerToBeRemoved.doesDocumentExist();
        if(doesSpeakerExists) {
          const speakerData = await this.speakerToBeRemoved.getSpeaker();

          speakerData.speakerRelations = speakerData.speakerRelations.filter(
              (item) => {
                return item.eventId != this.currentEvent.id && item.subEventId != this.currentSubEvent.id && item.sessionId != this.currentSession.id;
              }
          );
          speakerData.associatedSpeakerSessions = speakerData.associatedSpeakerSessions.filter(
              (sessionId) => sessionId != this.currentSession.id
          );
         await speakerData.save();
        }
      }

      //Save the event
      this.currentEvent.save();

      //Check if speaker had opted-in to the event
      // let hasOptedIn = this.currentSession.attendees.some(
      //   (attendee) => attendee.uid == this.speakerToBeRemoved.speakersUid
      // );

      //START: COMMENTED FOR SOUTH START
      // if (hasOptedIn) {
      //   let db = firebase.firestore();
      //   var batch = db.batch();

      //   // Send an in-app notification to the speaker
      //   batch.set(db.collection("notifications").doc(), {
      //     uid: this.speakerToBeRemoved.uid,
      //     businessCardId: this.speakerToBeRemoved.businessCardId,
      //     type: "SPEAKER_REMOVED_FROM_SESSION",
      //     createdOn: new Date(),
      //     multiConnectDocId: this.currentEvent.id,
      //     message:
      //       "You have been removed from " +
      //       this.currentSession.name +
      //       " as a speaker.",
      //   });
      //   batch.update(
      //     db
      //       .collection("business_cards")
      //       .doc(this.speakerToBeRemoved.businessCardId),
      //     {
      //       noOfNewNotifications: firebase.firestore.FieldValue.increment(1),
      //     }
      //   );
      //   await batch.commit();
      // } else {
      //   //Send an email to the speaker
      //   console.log("speaker hasn't opted in yet");
      //   // this.sendAccessRevokedEmail(this.currentEvent.name, "speaker");
      // }
      //END: COMMENTED FOR SOUTH START

      //Start: Remove speaker from this list if they were removed by the user
      // let removedInviteeIndex = this.sessionSpeakersDetails.findIndex(
      //   (invitee) => invitee.uid == this.speakerToBeRemoved.speakersUid
      // );

      // this.sessionSpeakersDetails.splice(removedInviteeIndex, 1);
      //End: Remove speaker from this list if they were removed by the user

      //Hide the dialog
      this.showConfirmationDialog = false;
      this.initializeSpeakers();
      this.showSnackbar({ show: true, text: "Speaker removed successfully!" });
    },
    async sendAccessRevokedEmail(eventName, role) {
      try {
        const sendAccessRevokedEmailNotification = getHttpsCallable("sendAccessRevokedEmailNotificationToInvitee");
        let result = await sendAccessRevokedEmailNotification({
          email: this.speakerToBeRemoved.invitedEmail,
          eventName: eventName,
          firstName: this.speakerToBeRemoved.firstName,
          lastName: this.speakerToBeRemoved.lastName,
          role: role,
        });
        return result;
      } catch (error) {
        console.log(
          "Error occurred while sending access revoked email to user: ",
          error
        );
      }
    },
    showBusinessCardOnDevice(businessCardId) {
      window.open("https://app.pappyon.com/businessCard/" + businessCardId);
    },
    initializeSpeakers() {

      this.currentEvent?.speakers.forEach((element) => {
        const attendeesSpeakerIds = this.currentEvent.attendees.filter((element) => element.speakerId!==undefined && element.speakerId!==null && element.speakerId!=="").map((e) => e.speakerId);

        if (attendeesSpeakerIds.includes(element.speakerId)) {
          element.status = "Joined";
        } else if (element.status === "" || element.status === undefined || element.status === null && element.status !== "Invited") {
          element.status = "Draft";
        }
      });

      this.speakers =
          this.currentEvent?.speakers?.filter(
              (speaker) =>
                  speaker.associatedSpeakerSessions.length > 0 &&
                  speaker.associatedSpeakerSessions.includes(this.currentSession.id)
          ) || [];
      //Refresh the table key to reflect property updates like email, image etc
    },
    getSpeakerStatus(speaker) {
      let hasJoined = this.currentSession.attendees.some(
        (attendee) => attendee.accessToken == speaker.accessToken
      );
      if (hasJoined) return "Joined";
      else return "Invited";
    },
    hasSpeakerOptedIn(speaker) {
      let hasOptedIn = this.currentSession.attendees.some(
        (attendee) => attendee.uid == speaker.speakersUid
      );
      return hasOptedIn;
    },
    handleShowAddSpeakerDialog() {
      let associatedSpeakerSessions = [this.currentSession.id];

      this.currentSpeaker = new Speaker({
        speakerRelations: [
          new SpeakerRelations(
              {
                eventId: this.currentEvent.id,
                subEventId: this.currentSubEvent.id,
                sessionId: this.currentSession.id,
              }
          )
        ],
        associatedSpeakerSessions: associatedSpeakerSessions,
      });

      this.isSpeakerEdit = false;
      this.showAddEditSpeakerDialog = true;


    },
    async handleAddSpeaker() {
      this.showAddEditSpeakerDialog = false;
      //this.initializeSpeakers();
    },

    async handleEditSpeaker(speaker) {
      const doesSpeakerExists = await speaker.doesDocumentExist();
      if(!doesSpeakerExists) {
        speaker.speakerId = "";
        speaker.speakerRelations = [
          new SpeakerRelations(
              {
                eventId: this.currentEvent.id,
                subEventId: this.currentSubEvent.id,
                sessionId: this.currentSession.id,
              }
          )
        ];
        const newSpeakerId =  await speaker.save();
        speaker.speakerId = newSpeakerId;
        this.currentSpeaker = await speaker.getSpeaker();
        let speakerIndex = this.currentEvent.speakers.findIndex(
            (speaker) => speaker.speakerId == this.currentSpeaker.speakerId
        );
        this.currentEvent.speakers.splice(
            speakerIndex,
            1,
            this.currentSpeaker
        );
      } else {
        const speakerInCollection = await speaker.getSpeaker();
        const relationIndex = speakerInCollection.speakerRelations.findIndex((item) => item.eventId == this.currentEvent.id && item.subEventId == this.currentSubEvent.id && item.sessionId == this.currentSession.id);
        if(relationIndex==-1) {
          speakerInCollection.speakerRelations.push(new SpeakerRelations(
              {
                eventId: this.currentEvent.id,
                subEventId: this.currentSubEvent.id,
                sessionId: this.currentSession.id,
              }
          ));
          await speakerInCollection.save();
        }
        this.currentSpeaker = await speakerInCollection.getSpeaker();
      }

      await this.$router.push(
          {
            name: "editSpeaker",
            params: {
              eventId: this.currentEvent.id,
              subEventId: this.currentSubEvent.id,
              sessionId: this.currentSession.id,
              speakerId: this.currentSpeaker.speakerId,
            },
          }
      )
      /*this.isSpeakerEdit = true;
      this.showAddEditSpeakerDialog = true;*/

      // this.$nextTick(() => this.$refs.addSpeakerForm.reset());
    },
    handleCloseAddEditSpeakerDialog() {
      this.showAddEditSpeakerDialog = false;
      this.currentSpeaker = {};
    },
    handleShowAddExistingSpeakerDialog() {
      this.showAddExistingSpeakerDialog = true;
    },
    customSearch(value, search, item) {
      search = search.toLowerCase();
      let name = item.firstName + " " + item.lastName;
      return name.toLowerCase().includes(search);

      // return Object.values(item).some((value) => {
      //   let name = item.firstName + " " + item.lastName;
      //   console.log("value in loop: ", value);
      //   return (
      //     // value.toLowerCase().includes(search) ||
      //     name.toLowerCase().includes(search)
      //   );
      // });
    },
    updateEventSpeaker() {

    },
    async addExistingSpeakersToSession() {
      let shouldSaveEvent = false;
      for (const speaker of this.selectedSpeakers) {
        const iterationIndex = this.selectedSpeakers.indexOf(speaker);
        //Find index of speaker from event
        let index = this.currentEvent.speakers.findIndex(
          (item) => item.speakerId == speaker.speakerId
        );

        //If speaker exists and current session's id hasn't been added to the speaker already then add id of current session to the speaker
        if (
          index != -1 &&
          !this.currentEvent.speakers[index].associatedSpeakerSessions.includes(
            this.currentSession.id
          )
        ) {
          this.currentEvent.speakers[index].associatedSpeakerSessions.push(
            this.currentSession.id
          );
        }
        const thisSpeaker = this.currentEvent.speakers[index];

        let speakerId = thisSpeaker.speakerId;


        if(speakerId == null || speakerId == undefined || speakerId == "" || speakerId.includes('-')) {
          this.currentEvent.speakers[index].speakerId = "";
          speakerId = await this.currentEvent.speakers[index].save();
          this.currentEvent.speakers[index].speakerId = speakerId;
        }else{
          const doesSpeakerExists = await thisSpeaker.doesDocumentExist();
          if (!doesSpeakerExists) {
            await this.currentEvent.speakers[index].save();
          }
        }
        const speakerData = await thisSpeaker.getSpeaker();
        speakerData.speakerRelations.push(
            new SpeakerRelations(
                {
                  eventId: this.currentEvent.id,
                  subEventId: this.currentSubEvent.id,
                  sessionId: this.currentSession.id,
                }
            )
        );

        await updateSpeakerDoc(speakerId, {
          associatedSpeakerSessions: this.currentEvent.speakers[index].associatedSpeakerSessions,
          speakerRelations: speakerData.speakerRelations?.map((item) => item.toObject())
        });

        if (iterationIndex == this.selectedSpeakers.length - 1)
          shouldSaveEvent = true;
      }
      if (shouldSaveEvent) {
        this.currentEvent.save();
      }
      this.showAddExistingSpeakerDialog = false;
      this.selectedSpeakers = [];
    },
    handleCloseExistingSpeakerDialog() {
      this.showAddExistingSpeakerDialog = false;
      this.selectedSpeakers = [];
    },
  },
};
</script>
<style>
</style>